import { useLocStrings } from '@office-start/loc-service';
import { format } from '@office-start/string-formatter-utility';
import { TuiLinks, } from '@office-start/teaching-ui-service';
import { useMemo } from 'react';
export function useTuiContent(displayIndex, totalSteps, currentStep) {
    var locStrings = useLocStrings().data;
    // Parse applicable content
    var _a = locStrings !== null && locStrings !== void 0 ? locStrings : {}, tuiContentStrings = _a.teachingUIContentResources, tuiComponentStrings = _a.teachingUIComponentResources;
    // Fetch localized content for the callout
    var content = useMemo(function () {
        if (!tuiContentStrings || !currentStep) {
            return undefined;
        }
        var _a = currentStep.content, textKey = _a.text, titleKey = _a.title, displayTextKey = _a.urlDisplayText, urlKey = _a.url;
        var text = tuiContentStrings[textKey];
        var title = titleKey ? tuiContentStrings[titleKey] : undefined;
        var urlDisplayText = displayTextKey
            ? tuiContentStrings[displayTextKey]
            : undefined;
        var url = urlKey ? TuiLinks.freemiumTuiRemindURL : undefined;
        var footer = totalSteps > 1 && (tuiComponentStrings === null || tuiComponentStrings === void 0 ? void 0 : tuiComponentStrings.calloutProgressText)
            ? format(tuiComponentStrings === null || tuiComponentStrings === void 0 ? void 0 : tuiComponentStrings.calloutProgressText, displayIndex.toString(), totalSteps.toString())
            : undefined;
        return {
            text: text,
            title: title,
            urlDisplayText: urlDisplayText,
            url: url,
            footer: footer,
        };
    }, [
        tuiComponentStrings,
        tuiContentStrings,
        currentStep,
        displayIndex,
        totalSteps,
    ]);
    return content;
}
//# sourceMappingURL=useTuiContent.js.map